import { Typography } from "@mui/material";
import { useState } from "react";
import { useRevalidator } from "react-router-dom";

import Modal from "../../../../../../components/global/Modal";
import ResponseModal from "../../../../../../components/global/ResponseModal";
import useService from "../../../../../../hooks/useService";

export default function DeleteExpense({
  activeExpense,
  deductionOpts,
  open,
  setActiveExpense,
  setOpen,
}) {
  const additionalExpenseRepository = useService("repositories/additional-expense-repository");
  const { revalidate } = useRevalidator();
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setActiveExpense(null);
  };

  const handleDelete = async () => {
    setLoading(true);

    try {
      await additionalExpenseRepository.delete(activeExpense.id);
      setLoading(false);
      setOpenSuccess(true);
      revalidate();
      handleClose();
    } catch (error) {
      setLoading(false);
      if (error.response) {
        setOpenError(!openError);
        const res = error.response.data;
        const errArr = [];
        for (const item in res) {
          errArr.push(item + `: ${res[item]}`);
        }
        setErrorArray(errArr);
      }
    }
  };

  return (
    <>
      <Modal
        open={open}
        fullWidth
        maxWidth="sm"
        title="Delete Expense"
        onClose={handleClose}
        actions={[
          {
            isLoading: loading,
            onClick: handleDelete,
            label: "Delete Expense",
            variant: "outlined",
            className: "border-red-500 text-red-500 hover:bg-red-500 hover:text-white",
          },
        ]}
      >
        <div className="flex w-full flex-wrap items-center p-6">
          <div className="flex w-full">
            <Typography variant="h6" className="w-fit text-lg font-bold">
              Label:
            </Typography>
            <Typography variant="h6" className="ml-2 w-fit text-lg">
              {activeExpense?.label ?? ""}
            </Typography>
          </div>
          <div className="flex w-full">
            <Typography variant="h6" className="w-fit text-lg font-bold">
              Amount:
            </Typography>
            <Typography variant="h6" className="ml-2 w-fit text-lg">
              {activeExpense?.amount ?? ""}
            </Typography>
          </div>
          <div className="flex w-full">
            <Typography variant="h6" className="w-fit text-lg font-bold">
              Deducted From:
            </Typography>
            <Typography variant="h6" className="ml-2 w-fit text-lg">
              {deductionOpts.find((opt) => opt.value === activeExpense?.deductionType)
                ?.display_name ?? ""}
            </Typography>
          </div>
        </div>
      </Modal>
      <ResponseModal
        title="Expense Removed"
        description="Expense has been successfully deleted"
        openBool={openSuccess}
        setOpenBool={setOpenSuccess}
        handleCloseFunc={() => setOpenSuccess(false)}
      />
      <ResponseModal
        title="Error Removing Expense"
        isError={true}
        openBool={openError}
        setOpenBool={setOpenError}
        errorMessage={errorArray}
      />
    </>
  );
}
